import cn from "classnames";
import React, { useCallback, useEffect, useState } from "react";
import Rules from "./Rules";
import SocialShare from "./SocialShare";
import { useSelector } from "react-redux";
import { Merchant, NewUser, Rider } from "../../icons";
import ReferralCard from "../../common/ReferralCard";
import { Autoplay, Pagination, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { Modal } from "antd";
import { getParamValue } from "../../../utils";
import { useLocation } from "react-router";
import axios from "axios";
import { Loader } from "../../common";
import { Link } from "react-router-dom";
const InviteEarn = () => {
  const { token, type, merchantInfo } = useSelector(
    (state) => (state as any)?.authReducer
  );
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");
  const [limit, setLimit] = useState(16);
  const [key, setKey] = useState("");
  const [isActive, setIsActive] = useState<any>(undefined);
  const [visible, setVisible] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [promotionData, setPromotionData] = useState<any>({
    loading: false,
    data: null,
  });
  const settings = {
    slidesPerView: 6,
    spaceBetween: 30,
    // pagination={true}
    pagination: {
      clickable: true,
    },
    navigation: true,
    breakpoints: {
      620: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      1024: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
      1600: {
        slidesPerView: 1,
        spaceBetween: 30,
      },
    },
    modules: [Autoplay, Pagination, Navigation],
  };
  const options = [
    {
      title: "Share with Friends",
      description:
        "Share this code with as many family members and friends as you want, and ask them to use it when signing up or placing an order at Jachai.com. In every purchase, both parties will benefit. ",
      icon: <NewUser />,
      referralCode: merchantInfo?.referralCode,
      colorCode: "rgba(185, 101, 224, 0.12)",
    },
    {
      title: "Share with Rider",
      description:
        "Share this code with as many family members and friends as you want, and ask them to use it when signing up or placing an order at Jachai.com. In every purchase, both parties will benefit. ",
      icon: <Rider />,
      referralCode: merchantInfo?.referralCode,
      colorCode: "#FDF0F0",
    },
    {
      title: "Share with Merchant",
      description:
        "Share this code with as many family members and friends as you want, and ask them to use it when signing up or placing an order at Jachai.com. In every purchase, both parties will benefit. ",
      icon: <Merchant />,
      referralCode: merchantInfo?.referralCode,
      colorCode: "#F4ECCE",
    },
  ];
  const getPromoCode = useCallback(async () => {
    setPromotionData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/promotion?type=${type}&placement=MARCHANT_DASHBOARD&page=${
          page || 0
        }&limit=${limit || 16}` +
          (key ? `&name=${key}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        setPromotionData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setPromotionData({ loading: false, data: [] });
        console.error("Promotion: Error", err);
      });
  }, [key, limit, page, isActive, type]);

  useEffect(() => {
    getPromoCode();
  }, [getPromoCode]);

  return (
    <>
      
        <div className="rounded-xl border bg-white min-h-full">
          <div className="relative h-80 w-full flex flex-col items-center justify-center p-6">
            <Swiper
            {...settings}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              className="w-full max-w-5xl"
            >
              {promotionData?.loading ? (
                <Loader />
              ) : (
                promotionData?.data?.promotions?.map((promotion, index) => (
                  <SwiperSlide key={index} className="w-full">
                    <div className="w-full bg-white shadow-md shadow-gray-200 hover:shadow-xl  border rounded-md text-center">
                      <div className="w-full h-full md:h-full overflow-hidden">
                        <Link to={promotion?.url}>
                          <img
                            src={promotion?.imageUrl}
                            alt=""
                            className="w-full h-full object-cover rounded-md"
                          />
                        </Link>
                      </div>
                    </div>
                  </SwiperSlide>
                ))
              )}
            </Swiper>

            <div
              className="absolute right-0 top-4 bg-gray-600 px-6 py-3 rounded-l-full text-white font-extrabold leading-3 shadow-md cursor-pointer hover:bg-red-600 z-50 mt-8"
              onClick={() => setVisibleModal(!visibleModal)}
            >
              Rules
            </div>
          </div>
          <div className="p-4 lg:p-10 flex flex-col justify-center gap-4">
            <div className="grid grid-cols-3 gap-6">
              {options?.map((data: any, i: number) => (
                <ReferralCard
                  data={data}
                  key={i}
                  setVisible={setVisible}
                  visible={visible}
                />
              ))}
            </div>

            {visible && (
              <>
                <span className="text-center font-bold text-xl lg:text-2xl mt-12">
                  Share this code
                </span>
                <SocialShare />
              </>
            )}
          </div>
        </div>
  
      <Modal
        open={visibleModal}
        onCancel={() => setVisibleModal(!visibleModal)}
        width={500}
        title={
          <span className="flex gap-4 justify-center font-semibold">
            “INVITE & EARN"
          </span>
        }
      >
        <Rules />
      </Modal>
    </>
  );
};

export default InviteEarn;
